module.exports = __webpack_public_path__ + "img/partner0_1.c879ea98.png";